import React from "react";
import ReactSelect, { components } from "react-select";
import classes from "./DropDown.module.css";
import PropTypes from "prop-types";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { mergeClass } from "../../../resources/utils/helper";

const CustomOption = (props) => {
  const { data, isSelected, imageClass, optionClass, isCheckbox } = props;

  return (
    <components.Option {...props}>
      <div className={mergeClass(classes.optionContainer, optionClass)}>
        {/* {data?.image ? (
          <div className={mergeClass(classes.imageDiv, imageClass)}>
            <img
              src={data.image}
              alt={data.label}
              fill
              className={classes.image}
            />
          </div>
        ) : (
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            className={classes.checkbox}
          />
        )} */}
        <label className={classes.optionLabel}>{data.label}</label>
      </div>
    </components.Option>
  );
};
const DropDown = ({
  options,
  label,
  customStyle,
  disabled,
  value,
  setValue,
  isCheckbox = false,
  placeholder,
  isMulti,
  style,
  leftIcon,
  Components,
  labelClassName,
  indicatorColor = "var(--secondary-clr)",
  optionLabel,
  optionValue,
  selectRef,
  isSearchable = true,
  borderRadius = "5px",
  classNamePrefix,
  customContainerClass,
  variant = "",
  customContainerStyle,
  inputClass,
  iconClass,
  errorText,
  imageClass,
  optionClass,
  ...props
}) => {
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {props.isFocused ? (
          <MdKeyboardArrowUp size={30} color={indicatorColor} />
        ) : (
          <MdKeyboardArrowDown size={30} color={indicatorColor} />
        )}
      </components.DropdownIndicator>
    );
  };

  const dropDownStyle = {
    control: (base, { isDisabled }) => ({
      ...base,
      backgroundColor: isDisabled
        ? "var(--disabled-input-clr)"
        : variant === "dashboard"
        ? "var(--dashboard-input-bg-clr)"
        : "var(--white-clr)",
      borderRadius,
      color: "var(--input-border-color)",
      boxShadow: "none",
      fontFamily: "var(--poppins)",
      fontSize: 16,
      cursor: "pointer",
      border:
        variant === "dashboard" ? "none" : `2px solid #cacaca`,
      ...customStyle,
      ":hover": {
        ...base[":hover"],
        borderColor: "var(--border-color)",
      },
    }),

    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "var(--black-color)",
      textTransform: "capitalize",
      fontFamily: "var(--poppins)",
      fontSize: "14px",
    }),

    option: (base, { isSelected }) => ({
      ...base,
      padding: "8px 12px",
      backgroundColor: isSelected ? "var(--white-color)" : null,
      color: isSelected ? "var(--black-color)" : "var(--black-color)",
      ":hover": {
        ...base[":hover"],
        backgroundColor: "var(--light-gray-v5)",
        cursor: "pointer",
      },
    }),
  };

  return (
    <div className={`${classes.Container}`} data-variant={variant}>
      {label && (
        <label
          htmlFor={`dropdown${label}`}
          className={`  ${[
            classes.label,
            labelClassName,
            disabled && classes.disabled,
          ].join(" ")}`}
        >
          {label}
        </label>
      )}

      <div
        className={`${classes.dropdownContainer} ${customContainerClass}`}
        style={{ ...customContainerStyle }}
      >
        <ReactSelect
          inputId={`dropdown${label}`}
          value={value}
          onChange={(e) => setValue(e)}
          className={`${classes.reactSelect} ${inputClass}`}
          isMulti={isMulti}
          isDisabled={disabled}
          placeholder={placeholder}
          options={options}
          styles={{ ...dropDownStyle, ...style }}
          isClearable={false}
          isSearchable={isSearchable}
          classNamePrefix={`DropdownOptionContainer ${classNamePrefix}`}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator,
            Option: (props) => (
              <CustomOption
                {...props}
                imageClass={imageClass}
                isCheckbox={isCheckbox}
              />
            ),
            ...Components,
          }}
          getOptionLabel={(option) =>
            optionLabel ? option[optionLabel] : option.label
          }
          getOptionValue={(option) =>
            optionValue ? option[optionValue] : option.value
          }
          ref={selectRef}
          {...props}
        />
        {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}
      </div>
      {errorText && <p className={`mt-2 ${classes.errorText}`}>{errorText}</p>}
    </div>
  );
};

export default DropDown;
